import {Component, Inject, Input, Optional, Output, EventEmitter} from "@angular/core";
import { ApiPathsService } from "../../../api-paths.service";
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-image-carousel',
  template: `
    <div class="vf-card" *ngIf="Oggetto">
      <div class="vf-photo-area" (click)="Oggetto.id_immagine || Oggetto.immagine ? uploadPhoto() : changeCover()">
        <div class="vf-photo-slots">
          <div class="vf-photo-main">
            <svg width="28" height="28" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>
            <span>+ Carica le foto</span>
          </div>
          <div *ngIf="Oggetto.id_immagine || Oggetto.immagine" class="vf-photo-thumb">

            <img [src]="Oggetto.id_immagine? api.getBaseAPI()+'/file/image/'+Oggetto.id_immagine: Oggetto.immagine">

            <button
              class="vf-change-cover"
              (click)="changeCover($event)"
            >
              Cambia
            </button>

            <div class="vf-cover-badge">
              Copertina
            </div>

          </div>
          <div *ngFor="let img of Oggetto.files " class="vf-photo-thumb"><img [src]="api.getBaseAPI()+'/file/image/'+img.id" ><button
            class="vf-remove-btn"
            (click)="removeFileImage(img, $event)"
          >
            ✕
          </button></div>
          <div *ngFor="let img of Oggetto.ImmaginiBase64; let i=index" class="vf-photo-thumb"><img [src]="img.immagine" > <button
            class="vf-remove-btn"
            (click)="removeBase64Image(i, $event)"
          >
            ✕
          </button></div>
          <div class="vf-photo-thumb" *ngFor="let i of missingImages"></div>
        </div>
      </div>
      <div class="vf-photo-hint">
        <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
        Cattura lo sguardo degli utenti con foto di alta qualità.
        <span class="vf-link" (click)="openPhotoModal(photoModal)">Scopri di più</span>
      </div>
    </div>

    <ng-template #photoModal>
      <div class="mdl">
        <div class="mh"><span class="mt2">Scegli uno sfondo neutro</span><button class="mx" (click)="closeModal('mFoto')">✕</button></div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;">
          <div class="vf-photo-ex good">
            <div class="vf-photo-ex-img">🧥</div>
            <div class="vf-photo-ex-badge good-b">✓</div>
          </div>
          <div class="vf-photo-ex bad">
            <div class="vf-photo-ex-img" style="background:linear-gradient(135deg,#555,#999)">🧥</div>
            <div class="vf-photo-ex-badge bad-b">✕</div>
          </div>
        </div>
        <p style="font-size:13px;color:var(--muted);line-height:1.6;margin-bottom:18px;">Usa uno sfondo chiaro e neutro per far risaltare l'articolo. Evita sfondi disordinati o con altri oggetti.</p>
<!--        <div style="display:flex;justify-content:center;gap:6px;margin-bottom:16px;">-->
<!--          <span style="width:8px;height:8px;border-radius:50%;background:var(&#45;&#45;teal);display:inline-block"></span>-->
<!--          <span style="width:8px;height:8px;border-radius:50%;background:var(&#45;&#45;border-d);display:inline-block"></span>-->
<!--          <span style="width:8px;height:8px;border-radius:50%;background:var(&#45;&#45;border-d);display:inline-block"></span>-->
<!--          <span style="width:8px;height:8px;border-radius:50%;background:var(&#45;&#45;border-d);display:inline-block"></span>-->
<!--        </div>-->
<!--        <div class="fa" style="margin-top:0">-->
<!--          <button class="btn-g" onclick="closeModal('mFoto')">Precedente</button>-->
<!--          <button class="btn-t" onclick="closeModal('mFoto');showToast('📸 Pronto per il caricamento!')">Avanti</button>-->
<!--        </div>-->
      </div>
    </ng-template>
  `,
  styles: [`
    .vf-card{
      background:var(--w);border:1px solid var(--border);border-radius:var(--rl);
      margin-bottom:12px;overflow:hidden;
    }
    .vf-photo-area{
      border:2px dashed var(--border-d);border-radius:10px;margin:16px 18px 0;
      cursor:pointer;transition:border-color .15s,background .15s;overflow:hidden;
    }
    .vf-photo-area:hover{border-color:var(--teal);background:var(--teal-l);}
    .vf-photo-slots{display:flex;gap:0;}
    .vf-photo-main{
      flex:0 0 220px;height:150px;display:flex;flex-direction:column;
      align-items:center;justify-content:center;gap:8px;
      color:var(--teal);font-size:13.5px;font-weight:800;
      border-right:1px solid var(--border);
      max-width: 200px;
    }
    .vf-photo-thumb{
      flex:1;height:150px;background:var(--bg);
      border-right:1px solid var(--border);
      max-width:20vw;position:relative;
      display:flex;align-items:center;
      justify-content:center;
    }

    .vf-photo-thumb img{
      width:100%;height:100%;
      object-fit:contain;
    }

    .vf-photo-thumb:last-child{
      border-right:none;
    }

    .vf-remove-btn{
      position:absolute;top:7px;right:7px;
      width:24px;height:24px;border:none;
      border-radius:50%;
      background:rgba(15,23,42,.75);
      color:#fff;font-size:12px;
      font-weight:700;cursor:pointer;
      display:flex;align-items:center;
      justify-content:center;
      opacity:0;z-index:20;
      transition:opacity .15s,background .15s,transform .15s;
    }

    .vf-photo-thumb:hover .vf-remove-btn{
      opacity:1;
    }

    .vf-remove-btn:hover{
      background:#ef4444;
      transform:scale(1.05);
    }
    .vf-cover-badge{
      position:absolute;left:8px;bottom:8px;
      background:var(--teal);color:#fff;
      padding:4px 8px;border-radius:7px;
      font-size:10px;font-weight:800;
      letter-spacing:.2px;z-index:10;
    }
    .vf-photo-hint{
      display:flex;align-items:center;gap:7px;
      padding:10px 18px 14px;font-size:12.5px;color:var(--muted);
    }
    .vf-link{color:var(--teal);font-weight:700;cursor:pointer;text-decoration:underline;}
    .vf-photo-ex{border-radius:10px;overflow:hidden;position:relative;height:140px;display:flex;align-items:center;justify-content:center;font-size:56px;}
    .vf-photo-ex.good{background:linear-gradient(135deg,#f0f0f0,#e8e8e8);}
    .vf-photo-ex.bad{background:linear-gradient(135deg,#888,#555);}
    .vf-photo-ex-badge{position:absolute;top:8px;left:8px;width:24px;height:24px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:900;color:#fff;}
    .vf-photo-ex-badge.good-b{background:var(--positive);}
    .vf-photo-ex-badge.bad-b{background:var(--red);}

    .vf-cta{display:flex;gap:9px;margin-top:20px;}
    .fa{display:flex;gap:9px;margin-top:18px;}
    .btn-t{background:#0F766E;color:#fff;border:none;border-radius:7px;padding:10px 20px;font-size:13.5px;font-weight:800;transition:background .12s;}
    .btn-t:hover{background:#0B5F59;}
    .btn-t:hover{background:var(--teal-d);}
    .btn-o{background:var(--w);color:var(--teal);border:2px solid var(--teal);border-radius:7px;padding:9px 18px;font-size:13.5px;font-weight:800;transition:all .12s;}
    .btn-o:hover{background:var(--teal-l);}
    .btn-g{background:none;border:1.5px solid var(--border-d);border-radius:7px;padding:9px 15px;font-size:13px;font-weight:700;color:var(--text);transition:all .12s;}
    .btn-g:hover{border-color:var(--teal);color:var(--teal);}
    .mh{display:flex;align-items:center;justify-content:space-between;margin-bottom:17px;}
    .mt2{font-size:16px;font-weight:900;}
    .mx{border:none;background:none;font-size:21px;color:var(--muted);}
    .mdl{background:var(--w);border-radius:14px;padding:25px;box-shadow:var(--s3);animation:fu .18s ease;}
    @keyframes fu{from{opacity:0;transform:translateY(13px);}to{opacity:1;transform:translateY(0);}
    }.vf-change-cover{
       position:absolute;

       top:8px;
       left:8px;

       border:none;
       border-radius:7px;

       padding:5px 10px;

       background:rgba(15,23,42,.75);
       color:#fff;

       font-size:11px;
       font-weight:700;

       cursor:pointer;

       z-index:20;

       transition:.15s;
     }

    .vf-change-cover:hover{
      background:var(--teal);
    }

  `]
})
export class ImageCarouselComponent{
  @Input() Oggetto:any;
  @Output() OggettoChange = new EventEmitter<any>();
  constructor(
    @Optional() @Inject('Oggetto') public oggetto: any,
    private api: ApiPathsService,
    private toastService: ToastrService,
    private modalService: NgbModal
  ){
    this.Oggetto = oggetto ?? this.Oggetto ;
    console.log(this.Oggetto, oggetto)
  }

  openPhotoModal(modal){
    this.modalService.open(modal, {
      container:'#main-wrapper',
      centered: true,
    });

  }
  closeModal(type){
    this.modalService.dismissAll();
  }
  uploadPhoto(){

    const input = document.createElement('input');

    input.type = 'file';

    input.onchange = () => {

      const file = input.files?.[0];

      if (!file) {

        this.toastService.error(
          'Nessun file selezionato'
        );

        return;
      }

      if (!file.type.includes('image')) {

        this.toastService.warning(
          "Questo formato non è supportato. Inserire solo Immagini.",
          "Attenzione!"
        );

        return;
      }

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {

        const immagineObj = {
          immagine: reader.result.toString(),
          filename: file.name
        };

        // COPERTINA
        if (
          !this.Oggetto.immagine &&
          !this.Oggetto.id_immagine
        ) {

          this.Oggetto.immagine =
            immagineObj.immagine;

          this.Oggetto.file =
            immagineObj.filename;

        }

        // IMMAGINI AGGIUNTIVE
        else {

          this.Oggetto.Immagini = [
            ...(this.Oggetto.Immagini ?? []),
            file
          ];

          this.Oggetto.ImmaginiBase64 = [
            ...(this.Oggetto.ImmaginiBase64 ?? []),
            immagineObj
          ];

        }

        this.OggettoChange.emit(
          this.Oggetto
        );

        console.log(
          "Oggetto Mod in imageCarousel",
          this.Oggetto
        );

      };

    };

    input.click();
  }
  changeCover(event?) {

    if (event) {
      event.stopPropagation();
    }

    const input = document.createElement('input');

    input.type = 'file';

    input.onchange = () => {

      const file = input.files?.[0];

      if (!file) {
        return;
      }

      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {

        this.Oggetto.immagine =
          reader.result.toString();

        this.Oggetto.file =
          file.name;

        // IMPORTANTISSIMO
        // forza backend a creare nuova cover
        this.Oggetto.old_id_immagine =
          this.Oggetto.id_immagine;

        this.Oggetto.id_immagine = null;

        this.OggettoChange.emit(
          this.Oggetto
        );

        console.log(
          "CHANGE COVER",
          this.Oggetto
        );

      };

    };

    input.click();
  }
  removeFileImage(img, event?) {

    if (event) {
      event.stopPropagation();
    }

    this.Oggetto.ImmaginiDelete =
      this.Oggetto.ImmaginiDelete || [];

    this.Oggetto.ImmaginiDelete.push(img.id);

    this.Oggetto.files =
      (this.Oggetto.files || [])
        .filter(f => f.id !== img.id);

    this.OggettoChange.emit(this.Oggetto);

  }
  removeBase64Image(index, event?) {

    if (event) {
      event.stopPropagation();
    }
    this.Oggetto.ImmaginiBase64.splice(index, 1);
    this.Oggetto.Immagini?.splice(index, 1);

    this.OggettoChange.emit(this.Oggetto);

  }

  get productImageList(){
    return [
      ...(this.Oggetto.id_immagine ? [{immagine: `${this.api.getBaseAPI()}/file/image/${this.Oggetto.id_immagine}`, filename:this.Oggetto.immagine, type:'copertina' }]: []),
      ...(this.Oggetto.ImmaginiBase64 ?? []),
      ...(this.Oggetto?.files?.map(f => ({immagine:  `${this.api.getBaseAPI()}/file/image/${this.Oggetto.id_immagine}`, filename: f.file, type:'file'}))??[])];
  }
  getCoverImage(){

    // preview temporanea cambio cover
    if (
      this.Oggetto.immagine &&
      !this.Oggetto.id_immagine
    ) {

      return this.Oggetto.immagine;

    }

    // immagine backend aggiornata
    if (this.Oggetto.id_immagine) {

      return (
        this.api.getBaseAPI() +
        '/file/image/' +
        this.Oggetto.id_immagine +
        '?t=' +
        new Date().getTime()
      );

    }

    return '';
  }
  get missingImages() {
    const current = this.productImageList?.length ?? 0;
    return Array.from({ length: Math.max(0, 4 - current) });
  }
}
